<template>
  <div class="wrap">
    <IpRangeListTargetingList
      :lists="lists"
      :items="items"
      :loading-lists="loadingLists"
      :loading-items="loadingItems"
      @getItems="getIPRangeListTargetingItems"
    />
  </div>
</template>

<script>
import { accountInitializer } from '@/mixins/accountInitializer'
import { setDrawerTypeAdvertiser } from '@/mixins/setDrawerTypeAdvertiser'
import { setToolbarTypeAdvertiser } from '@/mixins/setToolBarTypeAdvertiser'
import IpRangeListTargetingList from '@/components/Admin/IPRangeListTargeting/IPRangeListTargetingList'

export default {
  name: 'IPRangeListTargeting',
  components: { IpRangeListTargetingList },
  mixins: [
    accountInitializer,
    setDrawerTypeAdvertiser,
    setToolbarTypeAdvertiser,
  ],
  data() {
    return {
      loadingLists: true,
      loadingItems: true,
    }
  },
  computed: {
    lists() {
      return this.$store.getters['IPRangeListTargeting/lists']
    },
    items() {
      return this.$store.getters['IPRangeListTargeting/items']
    },
  },
  async created() {
    this.initIPRangeListTargeting()
  },
  methods: {
    async initIPRangeListTargeting() {
      this.loadingLists = true
      await this.$store.dispatch(
        'IPRangeListTargeting/GET_LISTS_FOR_ADVERTISER',
        {
          advertiserId: this.$route.params.advertiserId,
        },
      )
      this.loadingLists = false
    },
    async getIPRangeListTargetingItems(ipRangeListId) {
      // 201907 一旦実装しない扱いの機能、作ってしまったので置いておく
      this.loadingItems = true
      await this.$store.dispatch('IPRangeListTargeting/GET_ITEMS', {
        ipRangeListId,
      })
      this.loadingItems = false
    },
  },
}
</script>

<style scoped>
.wrap {
  width: 100%;
}
</style>
